import { Col, Container } from 'react-bootstrap';
import { type userSelector } from 'state/auth/auth.selectors';

interface Props {
  user: ReturnType<typeof userSelector>;
}

function LACTextV1({ user }: Props) {
  return (
    <>
      <Col
        xs={12}
        className="text-start"
      >
        <Container className="bg-light-gray border py-2">
          {user && <h5 className="fw-bold mb-1">{`Hello Dr. ${user.name}`}</h5>}
          <p className="m-0">You are one step away from being fully enrolled</p>
        </Container>

        <p className="mt-3">
          The DEA requires that an acting administrator, or equivalent person, grants you access to
          electronically prescribe controlled substances. This individual will verify that you are
          authorized to prescribe controlled substances under the DEA license number listed in the
          Logical Access Control (LAC) User Interface. This is typically the practice or hospital
          administrator.
        </p>
        <p className="text-purple fw-bold">Logical Access Control (LAC) User Details</p>
        <p className="mt-2">
          You will require someone from your practice to serve as the second authorizing user.
          Please enter the details for the second user below. This user will receive an email
          containing instructions on how to complete the final step. Note that you will need to be
          present with the user to enter your TFA credentials.
        </p>
      </Col>
    </>
  );
}

export default LACTextV1;
